import { Controller } from "@hotwired/stimulus"
import EditorJS from "@editorjs/editorjs"
import CodeTool from "@editorjs/code"
import Header from "@editorjs/header"
import ImageTool from "@editorjs/image"
import List from "@editorjs/list"
import Paragraph from "@editorjs/paragraph"

// Connects to data-controller="editor-js"
export default class extends Controller {
  static targets = ['input', 'hidden']
  static values = { parents: String }

  connect() {
    this.contentEditor = new EditorJS({
      holder: this.inputTarget,
      data: this.getInitialContent(),
      tools: {
        header: { class: Header },
        list: {
          class: List,
          inlineToolbar: true,
          config: {
            defaultStyle: 'unordered'
          }
        },
        paragraph: { 
          class: Paragraph, 
          config: { 
            inlineToolbar: true 
          } 
        },
        code: CodeTool,
        image: {
          class: ImageTool,
          config: {
            uploader: { uploadByFile: (file) => this.uploadFile(file) }
          }
        }
      }
    })

    this.element.closest('form').addEventListener('submit', this.saveEditorData.bind(this))

    // Editor.js backspace button won't work in the CodeTool and ListTool
    document.addEventListener('keydown', this.fixDeleteKeyIssue.bind(this), true)
  }

  disconnect() {
    // Editor.js backspace button won't work in the CodeTool and ListTool
    document.removeEventListener('keydown', this.fixDeleteKeyIssue.bind(this), true)
  }

  // Editor.js backspace button won't work in the CodeTool and ListTool
  fixDeleteKeyIssue(e) {

    // ListTool
    if (e.key === 'Backspace' && e.target.classList.contains('cdx-list')) {
      e.stopPropagation() 

      const selection = window.getSelection()
      const range = selection.getRangeAt(0)
      const listItem = range.startContainer.parentNode

      if (listItem.textContent === '') {
        e.stopPropagation()
        e.preventDefault() // Prevent the default backspace key action

        const list = listItem.parentNode

        // Remove the empty list item until there is only 1 left
        if (list.children.length > 1) {
          listItem.remove()
        }
      }
    }

    // CodeTool
    else if (e.key === 'Backspace' && e.target.classList.contains('ce-code__textarea')) {
      e.stopPropagation()
    }
  }

  getInitialContent() {
    if (this.hiddenTarget && this.hiddenTarget.value) {
      return JSON.parse(this.hiddenTarget.value)
    }
    return {}
  }

  async saveEditorData(e) {
    e.preventDefault()

    const outputData = await this.contentEditor.save()
    this.hiddenTarget.value = JSON.stringify(outputData)
    this.element.closest('form').submit()
  }

  csrfToken() {
    const ct = document.querySelector('meta[name="csrf-token"]')
    return ct ? ct.content : ''
  }

  async uploadFile(file) {
    const csrfToken = this.csrfToken()

    const formData = new FormData()
    formData.append('image', file)
    formData.append('authenticity_token', csrfToken)

    try {
      const response = await fetch(`/${this.parentsValue}/upload_editor_js_image`, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken },
        body: formData
      })

      const result = await response.json()
      // console.log('Upload result:', result)

      if (result.success) {
        return { success: 1, file: { url: result.file.url } }
      } 
      else {
        throw new Error(result.error)
      }
    } 
    catch (error) {
      // console.error('Upload error:', error)
      return { success: 0, error: error.message }
    }
  }
}